import Vue from 'vue'
import configs from '@/config'
import store from '@/store'
import constants from '@/constant'

let resource = null

const actions = {
  sendCountingUnique: {
    method: 'PUT',
    url: `${configs.liveProxyUrl}/api/live/counting/unique`,
  },
  sendCountingUniqueNewKafka: {
    method: 'PUT',
    url: `${configs.liveProxyUrl}/api/${constants.LiveProxyRootPath}/counting/unique`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sendCountingUnique = async (payload) => {
  if (store.getters['liveStatsV2/canSubmitNewLiveProxy']) {
    return resource.sendCountingUniqueNewKafka(payload)
  }
  return resource.sendCountingUnique(payload)
}

export default {
  initResource,
  sendCountingUnique,
}
